import { render, staticRenderFns } from "./TransportationService.vue?vue&type=template&id=428c3470&scoped=true&"
import script from "./TransportationService.vue?vue&type=script&lang=js&"
export * from "./TransportationService.vue?vue&type=script&lang=js&"
import style0 from "./TransportationService.vue?vue&type=style&index=0&id=428c3470&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428c3470",
  null
  
)

export default component.exports